
/**
 * Safely converts any input value to a number
 * @param value - The value to convert
 * @returns - A valid number or 0 if conversion fails
 */
export const getSafeNumber = (value: any): number => {
  if (typeof value === 'number') return value;
  if (!value) return 0;
  
  const num = parseFloat(String(value));
  return isNaN(num) ? 0 : num;
};
